import * as action_types from './actionTypes'

export const updateBreadcrumbs = data => dispatch => {
  dispatch({
    type: action_types.UPDATE_BREADCRUMBS,
    payload: data
  });
};



// WEBPACK FOOTER //
// ./src/actions/breadcrumbs.js